import React, { useState, Fragment } from "react";
import ModalVideo from "react-modal-video";

import "react-modal-video/scss/modal-video.scss";
import "./style.scss";

const EEarnInFiveMins = (props) => {
  const [_openModal, _setOpenModal] = useState(false);

  return (
    <>
      {props.content.edges && (
        <div id="earn-earn-in-five-mins" className="mt-auto">
          <div className="container">
            {props.content.edges.map((post, i) => (
              <div className="row" key={i}>
                <div className="col-lg-8 offset-lg-2 text-center">
                  <h2
                    className={`${post.node.acfPartials.pCssClasses} mb-4`}
                    dangerouslySetInnerHTML={{
                      __html: post.node.acfPartials.pHeading,
                    }}
                  />
                  <div
                    className="mb-5"
                    dangerouslySetInnerHTML={{
                      __html: post.node.acfPartials.pContent,
                    }}
                  />
                  <Fragment>
                    <ModalVideo
                      channel="youtube"
                      isOpen={_openModal}
                      videoId={post.node.acfPartials.pButtonUrl}
                      onClose={() => _setOpenModal(false)}
                    />
                    <button
                      className="button button-secondary mb-5"
                      onClick={() => _setOpenModal(true)}
                    >
                      {post.node.acfPartials.pButtonText}
                    </button>
                  </Fragment>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default EEarnInFiveMins;
